import { Azure } from './azure';
import { Bitbucket } from './bitbucket';
import { ServiceError } from './errors';
import { Github } from './github';
import { Gitlab } from './gitlab';
import { Service } from './service';

export function getService(
  service: string,
  host: string,
  usingToken: boolean = false,
  username: string | null
): Service {
  switch (service) {
    case 'github':
      return new Github(host);
    case 'gitlab':
      return new Gitlab(host);
    case 'bitbucket':
      return new Bitbucket(host, usingToken, username);
    case 'azure':
      return new Azure(host, usingToken);
    default:
      throw new ServiceError(
        'Unsupported service',
        'GitLive currently only supports GitHub, GitLab, Bitbucket and Azure DevOps'
      );
  }
}
